import React from 'react';
import { Label } from "reactstrap";
import { FieldProps } from 'formik'

const AnswerDefaultBox: React.FC<FieldProps & {
  id: string;
  label: string;
  value: string;
  alphabet?: any;
  show_quiz: boolean;
  padclass?: string;
}> = ({
  field: { name, value, onBlur },
  form: { setFieldValue },
  id,
  label,
  value: radioValue,
  alphabet,
  show_quiz,
  ...props
}) => {
    return (
      <Label className={`quiz-live-answer-comp label-ans ${props.padclass}`} htmlFor={id}>
        <div className="l-ans-comp">
          <span className="alpha">{alphabet}</span>
          <p>{label}</p>
       
        </div>
      </Label>
    );
  };

export default AnswerDefaultBox;